import { Col, Row } from 'antd';
import Box from 'components/Box';
import Text from 'components/Text';
import { formatCityStateZip } from 'features/report/pages/ReportPage/utils';
import reportSelectors from 'features/report/services/selectors';
import { sumBy } from 'lodash';
import moment from 'moment';
import shopSelectors from 'services/shop/selectors';
import styled from 'styled-components';
import { formatCurrency } from 'utils/formatCurrency';
import { PHONE_MASKED } from 'utils/mask';

type IPrintBodyProps = {
  isPrinter?: boolean;
  billRef?: React.RefObject<HTMLDivElement>;
};
const PrintReportDiscount = ({ billRef, isPrinter }: IPrintBodyProps) => {
  const shopInfo = shopSelectors.data.shopInfo();
  const dataHomeReportDiscount = reportSelectors.getDataHomeReportDiscount();
  return (
    <>
      <PrintBodyStyled id='receipt' className='PrintBodyCouponOnlyContainer'>
        <TicketBox ref={billRef} className='TicketBox'>
          <CountingBox>
            <div>
              <ShopText printMode variant="CONTENT_2" className='bold' style={{ fontSize: '1.5rem' }}>{shopInfo?.shopName || ''}</ShopText>
              <ShopText printMode variant="CONTENT_2" className={isPrinter ? 'bold' : ''} style={{ fontSize: '0.75rem' }}>
                {shopInfo?.address || ''}
              </ShopText>
              <ShopText printMode variant="CONTENT_2" className={isPrinter ? 'bold' : ''} style={{ fontSize: '0.75rem' }}>
                {formatCityStateZip(shopInfo?.city, shopInfo?.state, shopInfo?.zip)}
              </ShopText>
              <ShopText printMode variant="CONTENT_2" style={{ fontSize: '0.75rem' }}>
                {PHONE_MASKED.resolve(shopInfo?.phone || '')}
              </ShopText>
            </div>
          </CountingBox>
          <ColHeader className='time-title'>{moment().format('DD-MM-YYYY')}</ColHeader>
          <Box display="flex" flexDirection="column">
            <Header style={{ padding: '0 2px' }}>
              <ColHeader span={4}><Box>NO.</Box></ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }}>TIME</ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }}>STAFF</ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }}>OWNER</ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }}>DISC.</ColHeader>
            </Header>
            {dataHomeReportDiscount.map(o => (
              <Row key={o.billId} style={{ padding: '2px' }}>
                <ColHeader span={4}>
                  <Box display='flex'>
                    <Box highlight style={{ padding: '2px' }}>
                      <Text variant='CAPTION_2' printMode className='title-highlight' style={{ fontWeight: '600', lineHeight: '0.8125rem' }}>#{(o.billNumber)}</Text>
                    </Box>
                  </Box>
                </ColHeader>
                <ColHeader span={5} style={{ textAlign: 'start' }}><Text variant='CAPTION_2' printMode className='text'>{o.time}</Text></ColHeader>
                <ColHeader span={5} style={{ textAlign: 'start' }}><Text variant='CAPTION_2' printMode className='text'>{formatCurrency(o.staffDiscount)}</Text></ColHeader>
                <ColHeader span={5} style={{ textAlign: 'start' }}><Text variant='CAPTION_2' printMode className='text'>{formatCurrency(o.ownerDiscount)}</Text></ColHeader>
                <ColHeader span={5} style={{ textAlign: 'start' }}><Text variant='CAPTION_2' printMode className='text'>{formatCurrency(o.totalDiscount)}</Text></ColHeader>
              </Row>
            ))}
            <Footer style={{ padding: '0 2px' }}>
              <ColHeader span={9}><Box className='label'>TOTAL</Box></ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }} className='label'>{formatCurrency(sumBy(dataHomeReportDiscount, 'staffDiscount'))}</ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }} className='label'>{formatCurrency(sumBy(dataHomeReportDiscount, 'ownerDiscount'))}</ColHeader>
              <ColHeader span={5} style={{ textAlign: 'start' }} className='label'>{formatCurrency(sumBy(dataHomeReportDiscount, 'totalDiscount'))}</ColHeader>
            </Footer>
          </Box>
        </TicketBox>
      </PrintBodyStyled>
    </>
  );
};

export default PrintReportDiscount;
const PrintBodyStyled = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 6rem;
  // justify-content: center;
  flex-grow: 1;
  .shop_name {
    color: black;
    text-align: right;
    font-family: 'Roboto', serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 166.667% */
  }
  .shop_address, .shop_phone {
    color: black;
    font-family: 'Roboto', serif;
    text-align: right;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
  .customer_name {
    color: black;
    font-family: 'Roboto', serif;
    font-size: 1.25rem;
  }
`;
const TicketBox = styled.div`
  border-radius: 20px;
  background: #fff;
  width: 25.5rem;
  height: fit-content;
`;

const CountingBox = styled.div`
`;

const ShopText = styled(Text)`
  color: black;
  font-style: normal;
  font-family: 'Roboto', serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-align: center;

  &.bold {
    font-size: 0.8rem;
    font-weight: 700;
  }
`;

const FinalBox = styled.div<{ border?: boolean }>`
  padding: 0;
  text-align: center;
  font-weight: 400;
  .bold {
    font-weight: 500;
  }
  ${({ border }) => border && `
    margin-top: 1rem;
    padding-top: 0.5rem;
    margin-right: 1rem;
    margin-left: 1rem;
    border-top: 1px solid black;
  `}
`;


const Header = styled(Row)`
  // border-top:1px solid black;
  padding: 2px 0px;
  border-bottom: 1px dashed black;
`;
const Footer = styled(Row)`
  padding: 2px 0px;
  background: black;
  .label {
    color: white;
    font-size: 13px;
  }
`;

const ColHeader = styled(Col)`
    color:  black;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    .text {
      font-size: 13px;
    }

    &.time-title {
      color: black;
      text-align: center;
      font-size: 20px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      letter-spacing: 1px;
      margin-bottom: 8px;
    }
`;